<div class="drop-zone" [class.disabled]="loading">
  <button class="modal-close-btn" (click)="closeComponent()">x</button>
  <br>
  <h2>{{contentText}}</h2>
  <div *ngIf="files">
    <table class="w-full" *ngIf="files.length">
      <tr>
        <th></th>
        <th>File Name</th>
        <th class="text-center">Status</th>
      </tr>
      <tr *ngFor="let file of files; let i = index">
        <td class="w-1rem"></td>

        <td class="vertical-align-middle display-flex">
          <span><img src="../../../assets/document.svg" class="h-2rem w-2rem mr-10px"></span>
          <p class="text-left break-word">{{file}}</p>
        </td>

        <td class="w-8rem pb-3px">

          <button class="mybutton" [class.disabled]="loading" (click)="downloadFiles(file)">Download</button>

        </td>
      </tr>

    </table>

    <div class="overlay" *ngIf="loading">
      <span *ngIf="loading" class="loader"></span>
    </div>
  </div>
</div>
<br>